import $ from 'jquery'

export const homeColor = (menuColor) => {
    // $("html").css("background", menuColor.backgroundColor);
    $("body").css("color", menuColor.assetFontColor);
    $('.tile-lg').css("background-color", menuColor.assetBackgroundColor);
    $('.label').css('color', menuColor.assetFontSelectorColor);
    $('.heading').css('color', menuColor.assetFontSelectorColor);
    $('.button').css("background-color", menuColor.assetBackgroundSelectorColor)
    $('.button').css('color', menuColor.assetFontSelectorColor);
    $('.tile-scroller').css("background-color", menuColor.assetBackgroundColor);
    $('.widgets').css('color', menuColor.assetFontColor);
    $('.tile-scroller-header').css('color', menuColor.assetFontColor);
    $('.tile-sm').css("background-color", menuColor.assetBackgroundColor);
    $('.tile-selection').css("background-color", menuColor.assetBackgroundColor);
    // $('.heading').css('color', menuColor.assetFontColor);
    // $('.label').css('color', menuColor.assetFontColor);
    $('.user-stay').css("background-color", menuColor.assetBackgroundSelectorColor);
    $('.selected').css("outline-color", menuColor.assetBackgroundSelectorColor);
    $('.selected').css('color', menuColor.assetFontColor);
    $('.select-selected').css('color', menuColor.assetFontSelectorColor);
    
}

export const footerColor = (menuColor) => {

    $('footer').css("background-color", menuColor.assetBackgroundColor);
    $('footer').css("color", menuColor.assetFontColor);
    // $('.footButton').css("color", menuColor.assetFontColor);
    // $('.footButton').css("background-color", menuColor.assetBackgroundColor);
    // $('.selected').css("background-color", menuColor.assetBackgroundSelectorColor);
    // $('.selected').css("color", menuColor.assetFontSelectorColor);
    // $('.selected').css("color", menuColor.assetFontSelectorColor);
}

//-------------------hcomm config------------------------------

export const hCommColor = (menuColor) => {
    $('.label').css('color', menuColor.assetFontColor);
    $('.button').css("background-color", menuColor.assetBackgroundSelectorColor)
    $('.button').css('color', menuColor.assetFontSelectorColor);
    $('.widgets').css('color', menuColor.assetFontColor);
    $('.tile-sm').css("background-color", menuColor.assetBackgroundColor);
    $('.thumbnails::after').css("background-color", menuColor.assetBackgroundColor);
    $('.addon-button').css("background-color", menuColor.assetBackgroundSelectorColor)
    $('.addon-button').css('color', menuColor.assetFontSelectorColor);
    $('.thumb-heading').css('color', menuColor.assetFontColor);
    $('input').css('color', menuColor.assetFontColor);
    $('.tile').css("background-color", menuColor.assetBackgroundColor);
    $('.order-toggle').css("background-color", menuColor.assetBackgroundSelectorColor)
    $('.order-toggle').css('color', menuColor.assetFontSelectorColor);
    $('.inputSubmit').css("background-color", menuColor.assetBackgroundSelectorColor)
    $('.inputSubmit').css('color', menuColor.assetFontSelectorColor);
    $('.heading').css('color', menuColor.assetFontSelectorColor);
    $("header.inner-pages").css("background-color", menuColor.assetBackgroundSelectorColor)
    $("header.inner-pages").css('color', menuColor.assetFontSelectorColor)
}

//----------------popUp color config---------------------------

export const popUpConfig = (menuColor) => {
    $('.orders-container').css("background-color", menuColor.assetBackgroundColor);
    $('.order-toggle').css("background-color", menuColor.assetBackgroundSelectorColor);
    $('.order-toggle').css('color', menuColor.assetFontSelectorColor);
    $('.orderButton').css("background-color", menuColor.assetBackgroundSelectorColor);
    $('.orderButton').css('color', menuColor.assetFontSelectorColor);
}

export const widgetColors = (menuColor) => {
    //stay-conrols  controls-fixed
     $('.stay-info').css('color', menuColor.assetFontColor);
     $('.stay-conrols').css('color', menuColor.assetFontColor);
    //$('.stay-conrols').css('background-color', menuColor.assetBackgroundColor);
    $('#checkoutButton').css('background-color', menuColor.assetBackgroundSelectorColor);
    $('#checkoutButton').css('color', menuColor.assetFontSelectorColor);
   $(".stay-body .stay-conrols").css("background", "#fff");
}

//---------------------TV control--------------------------------

export const tvWidgetColors = (menuColor) => {
    //stay-conrols  controls-fixed
    //$('.widgets').css('color', menuColor.assetBackgroundColor);
    $('.nav-ok').css('background-color', menuColor.backgroundColor);
    $('.widgets').css('background-color', menuColor.backgroundColor);
    $('.widgets').css('color', menuColor.assetFontColor);
    $('.inner-pages').css('background-color', menuColor.backgroundColor);
    $('.heading').css('color', menuColor.assetFontColor);
    //$('.button-back').css('color', menuColor.assetFontColor);
    $('.button-container').css("background-color", menuColor.assetBackgroundSelectorColor);
    $('.button-container').css("color", menuColor.assetFontSelectorColor);
    $('.selected').css("background-color", menuColor.assetBackgroundSelectorColor);
    //buttons page
    $('.power').css("background-color", menuColor.assetBackgroundSelectorColor);
    $('.nav').css('color', menuColor.assetFontSelectorColor);
    $('.button-label').css('color', menuColor.assetFontColor);
    $('.radio-label').css('color', menuColor.assetFontColor);
    $('.button-icon').css('fill', menuColor.assetFontSelectorColor);
    $('.ch-buttons-nav').css('color', menuColor.assetFontColor);
    $('.ch-circle').css('background-color', menuColor.backgroundColor);
    $('.ch-circle').css('color', menuColor.assetFontColor);
    //login page
    $('.button').css("background-color", menuColor.assetBackgroundSelectorColor);
    $('.button').css("color", menuColor.assetFontSelectorColor);
    //TVChannel
    $('.ch-list-label').css("background-color", menuColor.assetBackgroundSelectorColor);
    $('.ch-list-label').css("color", menuColor.assetFontSelectorColor);
    $('.title').css('color', menuColor.assetFontColor);
    $('.desc').css('color', menuColor.assetFontColor);
    $('.ch-list-menu').css('background-color', menuColor.backgroundColor);

    $('.changesTextColor').css('color', menuColor.assetFontColor);
}

//-------------------Room Control-----------------
export const roomThemeColorConfig = (menuColor) => {
    // $('.heading').css('color', menuColor.assetFontSelectorColor); // --> commented this css for versante build, if anywhere it causes issue ask Raymond to fix this from dynamic css.
    $('.label').css('color', menuColor.assetFontSelectorColor);
    $('.thumbnails').css('background', menuColor.assetBackgroundColor);
    $('.thumbnails').css('color', menuColor.assetFontColor);
    // $('.selected').css("outline-color", menuColor.assetBackgroundSelectorColor);
    // $('.selected').css("background", menuColor.assetBackgroundSelectorColor);
    // $('.selected').css('color', menuColor.assetFontSelectorColor);
    $('.header-container').css("color", menuColor.assetBackgroundSelectorColor);
    // $('input:checked + .slider').css("background", "red")
}

//------------------guest request color config-------------

export const guestRequestColorConfig = (menuColor) => {
    $('.heading').css('color', menuColor.assetFontSelectorColor);
    $('.label').css('color', menuColor.assetFontSelectorColor);
    $('.thumbnails').css('background-color', menuColor.assetBackgroundColor);
    $('.thumbnails').css('color', menuColor.assetFontColor);
    $('.selected').css("outline-color", menuColor.assetBackgroundSelectorColor);
    $('.selected').css("background-color", menuColor.assetBackgroundSelectorColor);
    $('.selected').css('color', menuColor.assetFontSelectorColor);
    // $('.header-container').css("color", menuColor.assetBackgroundSelectorColor);
    // $('.tile-sm.selected').css('color', menuColor.assetFontSelectorColor);
    // $('input:checked + .slider').css("background", "red")
}

//------------------mobile checkin color config-------------

export const mobileCheckinColorConfig = (menuColor) => {
    $("button.primary").css("background-color",menuColor.assetBackgroundSelectorColor);
    $('button.primary').css('color', menuColor.assetFontSelectorColor);
    $("header.inner-pages").css("background",menuColor.assetBackgroundSelectorColor);
    $("header.inner-pages").css("color",menuColor.assetFontSelectorColor);
    $(".form-window-heading").css("background",menuColor.assetBackgroundSelectorColor);
    $(".form-window-heading").css("color",menuColor.assetFontSelectorColor);
}

//------------------custom location color config-------------

export const customLocationColorConfig = (menuColor) => {
    $("a.order-toggle").css("background-color",menuColor.assetBackgroundSelectorColor);
    $("a.order-toggle").css("color",menuColor.assetFontSelectorColor);
    $('input[type="submit"]').css("background-color",menuColor.assetBackgroundSelectorColor);
    $('input[type="submit"]').css("color",menuColor.assetFontSelectorColor);
}
//------------------notification color config-------------

export const notificationColorConfig = (menuColor) => {
    $("a.button").css("color",menuColor.assetFontSelectorColor);
    $("a.button").css("background-color",menuColor.assetBackgroundSelectorColor);
    $(".tile-selection.unread").css("border-color",menuColor.assetBackgroundSelectorColor);
    $("button.primary").css("background-color",menuColor.assetBackgroundSelectorColor);
    $('button.primary').css('color', menuColor.assetFontSelectorColor);
    $("header.inner-pages").css("background",menuColor.assetBackgroundSelectorColor);
    $("header.inner-pages").css("color",menuColor.assetFontSelectorColor);
}


export const clearConfig = (menuColor) => {
    // $('.selected').css("outline-color", menuColor.assetBackgroundSelectorColor);
    // $('.selected').css("background-color", menuColor.assetBackgroundColor);
    // $('.selected').css('color', menuColor.assetFontColor);
    // $('footer').css("background-color", menuColor.assetBackgroundColor);
    // $('footer').css("color", menuColor.assetFontColor);
}
